import React, { FormEvent } from "react";
import { api, CompanyEmployeeDto } from "shared/api";
import { useApiMethod, UseModalProps } from "shared/lib";
import { Entity, Error, LoadingDots, Modal } from "shared/ui";

export interface IEmployeeRemoveModal extends UseModalProps {
  companySlug: string;
  data: CompanyEmployeeDto;
}

export const EmployeeRemoveModal = (props: IEmployeeRemoveModal) => {
  const submit = useApiMethod(api.companyEmployee.companyEmployeeArchive);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    await submit.call(props.companySlug, props.data.id);
    await props.onSuccess();
  };

  return (
    <Modal onClose={props.close} width={450}>
      <form onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title>Удаление сотрудника</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Entity>
            <Entity.Field
              flex
              title={props.data.user.name || props.data.user.email}
              description={props.data.user.email}
              style={{ flexBasis: "fit-content" }}
            />
            <Entity.Field
              flex
              description={props.data.companyEmployeeRole.name}
              right
              style={{ flexBasis: "fit-content" }}
            />
          </Entity>

          {submit.error && <Error style={{ marginTop: 24 }}>{submit.error.message}</Error>}
        </Modal.Body>

        <Modal.Actions>
          <Modal.Action htmlType="button" onClick={props.close}>
            Отмена
          </Modal.Action>

          <Modal.Action htmlType="submit" disabled={submit.loading}>
            {!submit.loading ? "Удалить" : <LoadingDots size={4}>Удаление</LoadingDots>}
          </Modal.Action>
        </Modal.Actions>
      </form>
    </Modal>
  );
};

EmployeeRemoveModal.defaultProps = {};
